/**
 * 商户 api管理
 * 2018.8.4
 */

import ApiPort from "../config/api-port";
import HttpAxios from "./http-axios";
import GlobalConfig from '../config/global'
import {handleResponse, handleError} from '../lib/common';

const junziqianApi = GlobalConfig.domain.junziqianApi

export default {
  /**
   * 设置API用户回调地址信息
   * @param callbackUrl 回调地址配置|只用于签署回调
   * @param notifyUrl 回调地址配置|通用
   * @param notifyUrlAll 启用强制使用notifyUrl方式，包括签署回调也使用新的方式（1是 0不是）
   * @returns {Promise<T>}
   * @constructor
   */
  ApiUpdateNotifyUrl({callbackUrl, notifyUrl, notifyUrlAll}) {
    let url = junziqianApi + ApiPort.merchantController.updateNotifyUrl
    let jsonData = {callbackUrl: callbackUrl, notifyUrl: notifyUrl, notifyUrlAll: notifyUrlAll}

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError)
  },

  /**
   * 获取API用户回调地址信息
   * @constructor
   */
  APINotifyUrl() {
    let url = junziqianApi + ApiPort.merchantController.notifyUrl

    return HttpAxios.post(url, {})
      .then(handleResponse)
      .catch(handleError)
  }
}



// WEBPACK FOOTER //
// ./assets/js/http-serve/merchantController.js